import gql from 'graphql-tag'
import { etran } from '../../shared/fragments'

export default gql`
  mutation submitEtranApi($loanId: Int!) {
    submitEtranApi(input: { loanId: $loanId }) {
      ${etran}
      errors {
        status
        title
        detail
      }
    }
  }
`
